module.exports = __webpack_public_path__ + "static/media/latin-psd.0bb8bdb6.png";